import React from 'react';
import cx from 'classnames';

/**
 * @typedef {object} LargeButtonProps
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} onClick
 * @property {React.ReactNode|number} children
 * @property {string} [subText]
 * @property {string} [className]
 */

/**
 * @param {LargeButtonProps} props
 */
const LargeButton = props => {
  const { onClick, children, subText, className = '' } = props;

  return (
    <button className={cx('mashboard-button--large', className)} onClick={onClick}>
      {children}
      {subText && <p className='mashboard-button__subtext'>{subText}</p>}
    </button>
  );
};

export default LargeButton;
